import { gql } from "@apollo/client";

export const GET_HEADER_MENU = gql`
  query ($language: String!) {
    headerMenu(language: $language) {
      ... on HeaderType {
        __typename
        item
      }
      ... on ErrorResponse {
        ErrorCode
        ErrorReason
      }
    }
  }
`;

export const GET_HEADER_MENU_ADMIN = gql`
  query adminHeaderMenu {
    adminHeaderMenu {
      ... on HeaderType {
        __typename
        item
      }
      ... on ErrorResponse {
        ErrorCode
        ErrorReason
      }
    }
  }
`;

export const GET_PAGE = gql`
  query (
    $language: String!
    $slug: String
    $type: PageTypeChoicesStraw
    $id: Int
  ) {
    getPage(language: $language, slug: $slug, type: $type, id: $id) {
      ... on UserGetPageType {
        __typename
        properties
        data
        id
      }
      ... on ErrorResponse {
        ErrorCode
        ErrorReason
      }
    }
  }
`;

export const GET_PAGE_ADMIN = gql`
  query (
    $language: String
    $slug: String
    $type: PageTypeChoicesStraw
    $id: Int
  ) {
    adminGetPage(language: $language, slug: $slug, type: $type, id: $id) {
      ... on PageType {
        __typename
        properties
        data
        type
        isPublished
        hidden
        id
      }
      ... on ErrorResponse {
        ErrorCode
        ErrorReason
      }
    }
  }
`;

export const GET_ALL_PAGES_ADMIN = gql`
  query (
    $language: String!
    $type: PageTypeChoicesStraw
    $isPublished: Boolean
    $slug: String
    $search: String
    $pageSize: Int
    $pageNumber: Int
  ) {
    getAllPagesAdmin(
      language: $language
      type: $type
      isPublished: $isPublished
      slug: $slug
      search: $search
      pageSize: $pageSize
      pageNumber: $pageNumber
    ) {
      type
      isPublished
      properties
      data
      id
    }
  }
`;

export const GET_ALL_PAGES_USER = gql`
  query (
    $language: String!
    $type: PageTypeChoicesStraw
    $slug: String
    $search: String
    $pageSize: Int
    $pageNumber: Int
  ) {
    getAllPagesUser(
      language: $language
      type: $type
      slug: $slug
      search: $search
      pageSize: $pageSize
      pageNumber: $pageNumber
    ) {
      type
      isPublished
      properties
      data
      id
    }
  }
`;

export const GET_SET_ADMIN = gql`
  query ($id: Int!) {
    adminGetSet(id: $id) {
      ... on SetType {
        id
        setType
        title
        language
        data
      }
      ... on ErrorResponse {
        ErrorCode
        ErrorReason
      }
    }
  }
`;

export const GET_SET = gql`
  query ($id: Int!) {
    getSet(id: $id) {
      ... on SetType {
        id
        setType
        title
        language
        data
      }
      ... on ErrorResponse {
        ErrorCode
        ErrorReason
      }
    }
  }
`;

export const GET_ALL_SETS = gql`
  query ($language: String!, $setType: PageTypeChoicesStraw) {
    getAllSets(language: $language, setType: $setType) {
      ... on ErrorResponse {
        ErrorCode
        ErrorReason
      }
      ... on ListSetType {
        sets {
          id
          setType
          title
          language
          data
        }
      }
    }
  }
`;

export const GET_ALL_WIDGETS = gql`
  query ListOfWidgets {
    getAllWidgets {
      ... on ErrorResponse {
        ErrorCode
        ErrorReason
      }
      ... on ListWidgetType {
        widgets {
          id
          title
          type
          languages
        }
      }
    }
  }
`;

export const GET_WIDGET_ADMIN = gql`
  query ($id: Int!) {
    adminGetWidget(id: $id) {
      ... on ErrorResponse {
        ErrorCode
        ErrorReason
      }
      ... on WidgetType {
        id
        title
        type
        languages
      }
    }
  }
`;

export const GET_WIDGET = gql`
  query ($id: Int!, $language: String!) {
    getWidget(id: $id, language: $language) {
      ... on WidgetType {
        id
        title
        type
        languages
      }
    }
  }
`;

export const GET_PAGES_WITH_WIDGETS = gql`
  query ($widgetId: Int!) {
    pagesWithWidget(widgetId: $widgetId) {
      ... on ErrorResponse {
        ErrorCode
        ErrorReason
      }
      ... on ListPageType {
        pages
      }
    }
  }
`;
